<template>
	<div class="">
		<div class="form-group" >
			<h2 @click="show" class="job-types-padding col-sm-7"><b>{{ functionName }}</b></h2>
		</div>
	
		<span v-for="(item, index) in functions" class="" :key="index">
			<!-- <div class="hidden">{{checkSelected(item.id, index)}}</div> -->
			<div  class="form-group col-sm-12"> 
				<span class="ml-5">{{item.name}}  </span>
				<label class="switch pull-right">
					<input type="checkbox" :checked="checkValue(item.id, index) == true" @click="toggleFunction(item.id, index, $event)">
					<span class="slider round"></span>
				</label>
			</div>	
		</span>
	</div>
</template>
<script>
export default {
	props: [
		'functions',
		'functionName',
		'selectedFunctions',
		'functionsArray',
		'functionsIndex',
		'atLeastOne'
	],
	data () {
		return {
			dropdown: 0
		}
	},
	// created: {
	// },
	methods: {
		show(event) {
			if (!this.dropdown) {
				this.dropdown = 1;
				return;
			}
			this.dropdown = 0;			
		},
		checkValue(id,jobIndex) { 
			let f = this.selectedFunctions
			if (f.includes(id)) {
				this.functionsArray[this.functionsIndex].functions[jobIndex].selected = true;
				return true
			}
			return false;
		},
		toggleFunction(id, jobIndex, event) {
			this.functionsArray[this.functionsIndex].functions[jobIndex].selected = event.target.checked;

		},
	}
}
</script>


<style scoped>

</style>